import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { revokeReprintAuth } from "../../services";
import { ReprintAuthRow } from "../../types/reprintAuth.type";
import { CHARCOAL } from "./data";

interface RevokeDialogProps {
  open: boolean;
  grant: ReprintAuthRow | null;
  onClose: () => void;
  onRevoked: () => void;
}

export default function RevokeDialog({
  open,
  grant,
  onClose,
  onRevoked,
}: RevokeDialogProps) {
  const [loading, setLoading] = useState<boolean>(false);
  // Local-only note. NOTE: the backend does NOT persist a revoke reason, so this
  // is never submitted — it is only an on-screen note for the operator.
  const [note, setNote] = useState<string>("");

  useEffect(() => {
    if (open) setNote("");
  }, [open]);

  const handleRevoke = async () => {
    if (!grant) return;
    setLoading(true);
    try {
      await revokeReprintAuth(grant.uuid);
      onRevoked();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 700, color: CHARCOAL }}>
        ยกเลิกสิทธิ์พิมพ์ซ้ำ?
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary">
          หลังยกเลิก พนักงานขายจะไม่สามารถพิมพ์บิลนี้ซ้ำได้อีก
          การกระทำนี้จะถูกบันทึกใน audit log
        </Typography>
        {grant && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {grant.transaction_no}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {grant.customer_name} · {grant.customer_code}
            </Typography>
          </Box>
        )}
        <TextField
          label="เหตุผลการยกเลิก (บันทึกส่วนตัว ไม่ถูกจัดเก็บ)"
          placeholder="ระบุเหตุผล"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          fullWidth
          multiline
          rows={2}
          size="small"
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          ยกเลิก
        </Button>
        <Button
          onClick={handleRevoke}
          variant="contained"
          color="error"
          loading={loading}
        >
          ยืนยันยกเลิกสิทธิ์
        </Button>
      </DialogActions>
    </Dialog>
  );
}
